export function UnfoldHamburgerMenu({ isOpen }) {
  return (
    <div className="hamburger-menu-div">
      <div
        style={{
          display: "flex",
          flexDirection: "column",

          listStyle: "none",
          overflow: "hidden",
          maxHeight: isOpen ? "500px" : "0",
          transition: "max-height 0.5s ease",
          borderRadius: "4px",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <div className="background-stripe">
          <a href="https://github.com/Eliya-G">
                    <img
                      className="svg-glow top-link-menu-icon"
                      src="/tech_icons/github.svg"
                      alt=""
                      height="30px"
                      width="30px"
                    />
          </a>
        </div>
        <a href="https://www.linkedin.com/in/eliya-gopkalo/">
        <img className="svg-glow top-link-menu-icon" src="/tech_icons/linkedin.svg" alt="" height="30px" width="30px"/>
        </a>
        <div className="background-stripe">
          <a href="mailto:eliya.gop1@gmail.com">
          <img
          className="svg-glow top-link-menu-icon"
          src="/tech_icons/email.svg"
          alt=""
          height="30px"
          width="30px"
          />
          </a>
        </div>

        <a href="tel:6478609006">
          <img
          className="svg-glow top-link-menu-icon"
          src="/tech_icons/phone.svg"
          alt=""
          height="30px"
          width="30px"
          />
        </a>
        <div className="background-stripe" style={{ height: "8px" }}></div>
      </div>
    </div>
  );
}
